import dynamic from 'next/dynamic';
import { MemberAccessPanelProps } from './member-access-panel';

export const MemberAccessPanel = dynamic<MemberAccessPanelProps>(
    () => import('./member-access-panel').then((mod) => mod.MemberAccessPanel),
    {
        ssr: false,
    }
);
